/* React hooks */
import { createContext, useState } from "react";


const DeceasedContext = createContext({ });

export const DeceasedProvider = ({ children }) => {
    const [ adminInfos, setAdminInfos ] = useState(null );
    const [ affiliationList, setAffiliationList ] = useState();
    const [ childInfos, setChildInfos ] = useState(null );
    const [ childrenInfos, setChildrenInfos ] = useState(null );
    const [ condolenceList, setCondolenceList ] = useState([]);
    const [ correspondentInfos, setCorrespondentInfos ] = useState(null );
    const [ deceased, setDeceased ] = useState();
    const [ deceasedAdvancedInfos, setDeceasedAdvancedInfos ] = useState([]);
    const [ deceasedFilteredList, setDeceasedFilteredList ] = useState([]);
    const [ deceasedInfos, setDeceasedInfos ] = useState();
    const [ deceasedList, setDeceasedList ] = useState(null );
    const [ eventList, setEventList ] = useState([]);
    const [ lastDeceased, setLastDeceased ] = useState('');
    const [ lomacoData, setLomacoData ] = useState([]);
    const [ newForm, setNewForm ] = useState({});
    // undefined tant que la requête n'a pas encore répondu (distinct d'un défunt sans conjoint,
    // pour lequel la réponse de l'API est toujours un objet, jamais null/undefined).
    const [ partnerInfos, setPartnerInfos ] = useState();
    const [ titleList, setTitleList ] = useState([]);
    const [ test, setTest ] = useState();

    return (
        <DeceasedContext.Provider value={{
            adminInfos, setAdminInfos,
            affiliationList, setAffiliationList,
            childInfos, setChildInfos,
            childrenInfos, setChildrenInfos,
            condolenceList, setCondolenceList,
            correspondentInfos, setCorrespondentInfos,
            deceased, setDeceased,
            deceasedAdvancedInfos, setDeceasedAdvancedInfos,
            deceasedInfos, setDeceasedInfos,
            deceasedFilteredList, setDeceasedFilteredList,
            deceasedList, setDeceasedList,
            eventList, setEventList,
            lastDeceased, setLastDeceased,
            lomacoData, setLomacoData,
            newForm, setNewForm,
            partnerInfos, setPartnerInfos,
            titleList, setTitleList,
            test, setTest
        }}>
            { children }
        </DeceasedContext.Provider>
    )
}

export default DeceasedContext;